/**
 * @readonly
 * @enum {string} - scope of the ev profiling service data
 */
export const ElectricVehicleProfileScopeTypes = Object.freeze({
    GENERATION: 'GENERATION',
    OBJECT: 'OBJECT'
})
